import { DrawerPortal } from './DrawerPortal';
import { useDrawerStore } from '../useDrawerStore';

export const DrawerPortals = () => {
  const left = useDrawerStore((state) => state.left);
  const right = useDrawerStore((state) => state.right);

  return (
    <>
      {left?.width > 0 && left.Component && (
        <DrawerPortal anchor="left" Component={left.Component} props={left.props} />
      )}
      {right?.width > 0 && right.Component && (
        <DrawerPortal anchor="right" Component={right.Component} props={right.props} />
      )}
    </>
  );
};
